export function normalizeName(s: string): string {
  return s.trim().toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

export async function computeImageHash(base64: string): Promise<string> {
  const sample = base64.slice(0, 120_000);
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(sample));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, "0")).join("");
}

export function computePerceptualHash(imageDataUrl: string): Promise<string> {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 9; canvas.height = 8;
      const ctx = canvas.getContext("2d");
      if (!ctx) { resolve("0".repeat(64)); return; }
      ctx.drawImage(img, 0, 0, 9, 8);
      const px = ctx.getImageData(0, 0, 9, 8).data;
      const gray = (i: number) => 0.299 * px[i*4] + 0.587 * px[i*4+1] + 0.114 * px[i*4+2];
      let hash = "";
      for (let y = 0; y < 8; y++)
        for (let x = 0; x < 8; x++)
          hash += gray(y * 9 + x) > gray(y * 9 + x + 1) ? "1" : "0";
      resolve(hash);
    };
    img.onerror = () => resolve("0".repeat(64));
    img.src = imageDataUrl;
  });
}

export function hammingDistance(a: string, b: string): number {
  let d = 0;
  for (let i = 0; i < Math.min(a.length, b.length); i++) if (a[i] !== b[i]) d++;
  return d;
}
